import { type FC } from 'react';

import { type PlantType } from '@/common/types/common';
import { type BoostType } from '@/common/types/factoryType';

import { AdsBoostButton } from './AdsBoostButton';
import CryptoBoostButton from './CryptoBoostButton';
import { FreeBoostButton } from './FreeBoostButton';
import { PaidBoostButton } from './PaidBoostButton';

interface BoostButtonProps {
  kind: BoostType;
  nextUseInSeconds?: number;
  tgemBoostX5X10?: number;
  plantId?: string;
  plantType: PlantType;
  effectMultiplier: number;
  tgemCost?: number;
  tgStarsPrice?: number;
  duration?: number;
}

const BoostButton: FC<BoostButtonProps> = ({
  kind,
  nextUseInSeconds,
  tgemBoostX5X10,
  plantId,
  plantType,
  effectMultiplier,
  tgemCost,
  duration,
}) => {
  switch (kind) {
    case 'Free': {
      return (
        <FreeBoostButton
          plantType={plantType}
          effectMultiplier={effectMultiplier}
          duration={duration}
          nextUseInSeconds={nextUseInSeconds}
        />
      );
    }
    case 'Advertising': {
      return (
        <AdsBoostButton
          plantId={plantId}
          plantType={plantType}
          effectMultiplier={effectMultiplier}
          duration={duration}
          nextUseInSeconds={nextUseInSeconds}
        />
      );
    }
    case 'Paid':
    case 'VIP': {
      return (
        <PaidBoostButton
          boostType={kind}
          plantType={plantType}
          effectMultiplier={effectMultiplier}
          plantId={plantId}
          tgemCost={tgemCost}
        />
      );
    }
    case 'BoostForCrypto': {
      return (
        <CryptoBoostButton
          plantId={plantId}
          plantType={plantType}
          tgemBoostX5X10={tgemBoostX5X10}
          effectMultiplier={effectMultiplier}
          nextUseInSeconds={nextUseInSeconds}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export { BoostButton };
